'use strict'

var Marionette = require('marionette')
var App = require('app')
var _ = require('lodash')

var DialogComponent = require('src/components/dialog-view')
var rhmRegisters = require("src/common/app-constants-rhm").rhmRegister;
var rhmStates = require("src/common/app-constants-rhm").states;

/**
 * Dialog body view
 * -----------------------------------------------------------------------------
 * Body of the dialog
 */
var DialogBody = DialogComponent.Body.extend({
  template: require('./templates/body.html'),
  events: {
    'change .js-preset-select': 'onPresetChange',
    'click .js-enable-group-edit': 'onEnableGroupEdit'
  },
  templateContext: function () {
    var self = this
    return {
      getRegisterPicklistOptions: function() {
        let registerKey = parseInt(self.options.register.key);
        let register = _.find(rhmRegisters, {regAddr:registerKey});
        let state = _.find(rhmStates, {type:register.type});
        return state.states;
      },
      getRegisterValueType: function() {
        let registerKey = parseInt(self.options.register.key);
        let register = _.find(rhmRegisters, {regAddr:registerKey});
        let state = _.find(rhmStates, {type:register.type});

        if (state) {
          return 'picklist'
        } else {
          return 'number'
        }

      },
      getRegisterLabel: function() {
        let registerKey = parseInt(self.options.register.key);
        let register = _.find(rhmRegisters, {regAddr:registerKey})
        return register.label;
      },
      getRegisterValue: function() {
        return self.options.register.value
      }
    }
  }
})

/**
 * Dialog view
 * -----------------------------------------------------------------------------
 * The dialog view
 */
var DialogView = DialogComponent.Layout.extend({
  className: 'dialog dialog-device-edit',
  childViewTriggers: {
    'dialog:load-preset': 'dialog:load-preset'
  },
  modelEvents: {
    'change': false
  },
  onRender: function () {
    var bodyView = new DialogBody(this.options)
    this.showChildView('bodyRegion', bodyView)
  }
})

module.exports.Layout = DialogView



// WEBPACK FOOTER //
// ./js/modules/devices/register/view.js